/* This example requires Tailwind CSS v2.0+ */
import { useContext } from 'react';
import get from 'lodash/get';
import './Shell.css';
import { FarmContext } from './FarmContext';
import { AppContext } from './AppContext';
import CompProperties from './CompProperties';
import FKDProperties from './FKDProperties';
import County from './County';
import CropHistory from './CropHistory';
import FKD from './FKD';
import { SoilTable } from './Soils';
import { SidebarContents } from './CoreLogicOwnerTransfer';
import { DateControl } from './NDVI';
import { FloodDateControl } from './Flood';
import ImportControl from './ImportControl';
// import DataPanel from './DataPanel';



function Properties() {
  // TODO model === 'comp' could just be (compId !=== undefined?)
  const { model } = useContext(FarmContext);
  if (model === 'comp') return <CompProperties />
  if (model === 'knowledge') return <FKDProperties />
}


function DataPanel({children}){
  return <div className="p-6 overflow-y-auto h-full">
    {children}
  </div>
}

export default function RightBarContents() {
  const { showing, toggleShowing } = useContext(AppContext);
  const { ssurgoMapunits } = useContext(FarmContext);

  // TODO toggleShowing not used here, add the toggle next to the title

  if (get(showing, 'FKD', false)) return <DataPanel open={true} setOpen={() => toggleShowing('FKD')}> <FKD /> </DataPanel>
  if (get(showing, 'Properties', false)) return <DataPanel open={true} setOpen={() => toggleShowing('Properties')}> <Properties /> </DataPanel>
  if (get(showing, 'County Stats', false)) return <DataPanel open={true} setOpen={() => toggleShowing('County Stats')}> <County /> </DataPanel>
  if (get(showing, 'Crop History', false)) return <DataPanel open={true} setOpen={() => toggleShowing('Crop History')}> <CropHistory /> </DataPanel>

  return <div>
    {showing['WIP Flood'] && <FloodDateControl />}
    {showing['NDVI'] && <DateControl />}
    {showing['Courthouse Comps'] && <SidebarContents />}
    {showing['Soils'] && <SoilTable ssurgoMapunits={ssurgoMapunits} />}
    {showing['Boundary'] && <ImportControl />}
  </div>
}
